import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
const Nosotros = lazy(() => import("@/pages/Nosotros"));
const Servicios = lazy(() => import("@/pages/Servicios"));
const Noticias = lazy(() => import("@/pages/Noticias"));
const Contacto = lazy(() => import("@/pages/Contacto"));
const PoliticaProteccionDatos = lazy(() => import("@/pages/PoliticaProteccionDatos"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<div className="route-loading" role="status">Cargando página…</div>}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/politica-proteccion-datos" element={<PoliticaProteccionDatos />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "hsl(230 55% 9%)",
            color: "white",
            border: "1px solid hsl(188 92% 52% / 0.25)",
          },
        }}
      />
    </div>
  );
}

export default App;
